import { render, staticRenderFns } from "./multiselect-group_new.vue?vue&type=template&id=72ee86ec&"
import script from "./multiselect-group_new.vue?vue&type=script&lang=js&"
export * from "./multiselect-group_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports